import { useTranslation } from 'react-i18next';
import { Header } from "./landing/Header";
import { Footer } from "./landing/Footer";
import { Users, Target, Zap, Shield } from "lucide-react";

const About = () => {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-hero py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-t1 mb-6">
              {t('landing.about.heroTitle')}
            </h1>
            <p className="text-xl text-t1/80 max-w-3xl mx-auto">
              {t('landing.about.heroSubtitle')}
            </p>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-foreground mb-6">{t('landing.about.missionTitle')}</h2>
                <p className="text-muted-foreground text-lg mb-6">
                  {t('landing.about.missionText1')}
                </p>
                <p className="text-muted-foreground text-lg">
                  {t('landing.about.missionText2')}
                </p>
              </div>
              <div className="bg-gradient-subtle p-8 rounded-lg">
                <img
                  src="/lovable-uploads/e4d0837c-a05d-4b30-958b-a9c2b63609de.png"
                  alt="Restaurant management illustration"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-foreground mb-4">{t('landing.about.valuesTitle')}</h2>
              <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
                {t('landing.about.valuesSubtitle')}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Target className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">{t('landing.about.value1Title')}</h3>
                <p className="text-muted-foreground">
                  {t('landing.about.value1Desc')}
                </p>
              </div>

              <div className="text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">{t('landing.about.value2Title')}</h3>
                <p className="text-muted-foreground">
                  {t('landing.about.value2Desc')}
                </p>
              </div>

              <div className="text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Zap className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">{t('landing.about.value3Title')}</h3>
                <p className="text-muted-foreground">
                  {t('landing.about.value3Desc')}
                </p>
              </div>

              <div className="text-center">
                <div className="bg-primary/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">{t('landing.about.value4Title')}</h3>
                <p className="text-muted-foreground">
                  {t('landing.about.value4Desc')}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl font-bold text-foreground mb-8">{t('landing.about.storyTitle')}</h2>
              <div className="text-muted-foreground text-lg space-y-6">
                <p>{t('landing.about.storyText1')}</p>
                <p>{t('landing.about.storyText2')}</p>
                <p>{t('landing.about.storyText3')}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
